// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"9775bb58","97":"1fd2b261","205":"72a4063e","336":"1fd2b261","384":"9775bb58","445":"1fd2b261","480":"9775bb58","724":"990555c7"}[chunkId] + ".chunk.css";
};